import { DataTableTypes } from '../../DataTableTypes';
import { dataTableDefaultProps } from '../const/defaultValues';

export function toTableModelWithDefaults<
  QUERY_MODEL extends DataTableTypes.QueryModel,
  SORT_MODEL extends DataTableTypes.SortModel
>(
  prevModel: DeepPartial<DataTableTypes.TableModel<QUERY_MODEL, SORT_MODEL>> | undefined,
  nextModel: DeepPartial<DataTableTypes.TableModel<QUERY_MODEL, SORT_MODEL>> | undefined
): DataTableTypes.TableModel<QUERY_MODEL, SORT_MODEL> {
  const prevCopy = { ...prevModel };
  return toTableModel<QUERY_MODEL, SORT_MODEL>({
    page: {
      offset: nextModel?.page?.offset ?? prevCopy?.page?.offset,
      limit: nextModel?.page?.limit ?? prevCopy?.page?.limit
    },
    sort: nextModel?.sort as DataTableTypes.InputTableModel<QUERY_MODEL, SORT_MODEL>['sort'],
    query: (nextModel?.query ?? {}) as QUERY_MODEL
  });
}

export function toTableModel<
  QUERY_MODEL extends DataTableTypes.QueryModel,
  SORT_MODEL extends DataTableTypes.SortModel
>(
  model:
    | DeepPartial<DataTableTypes.TableModel<QUERY_MODEL, SORT_MODEL>>
    | DataTableTypes.InputTableModel<QUERY_MODEL, SORT_MODEL>
    | undefined
): DataTableTypes.TableModel<QUERY_MODEL, SORT_MODEL> {
  const copy = { ...model };
  return {
    page: {
      offset: hasPageModelQuery(copy)
        ? (copy?.page?.offset ?? dataTableDefaultProps.offset)
        : dataTableDefaultProps.offset,
      limit: hasPageModelQuery(copy) ? (copy?.page?.limit ?? dataTableDefaultProps.limit) : dataTableDefaultProps.limit
    },
    sort: 'sort' in copy ? (copy.sort as DataTableTypes.SortModelQuery<SORT_MODEL>[]) : undefined,
    query: ('query' in copy ? copy.query : {}) as QUERY_MODEL
  };
}

function hasPageModelQuery(model: any): model is { page: DataTableTypes.PageModelQuery } {
  return !!model && 'page' in model;
}
